module.exports = __webpack_public_path__ + "static/aga-hero-484a5c65eea0b39314f52ffa1ed6c1d0.jpg";